// colors
export const BorderColor = "rgb(188, 97, 97)";
export const DarkBorderColor = "rgb(27, 23, 37)";
export const LightTextColor = "rgb(244, 241, 187)";
export const LightTextTransparentColor = "rgba(244, 241, 187, 0.5)";
export const LinkTextColor = LightTextColor;
export const LinkTextHoverColor = "rgb(155, 193, 188)";
export const GenreTagBackgroundColor = "rgb(27, 23, 37)";
export const GenreTagTextColor = "rgb(244, 241, 187)";
export const SearchBarBackgroundColor = "rgb(188, 97, 97)";
export const PlaceholderTextColor = LinkTextColor;
export const TextColor = "rgb(27, 23, 37)";
export const ConcertListBackgroundColor = "rgb(188, 97, 97)";
export const PaginationBackgroundColor = SearchBarBackgroundColor;
export const DarkBackgroundColor = "rgb(170, 85, 85)";
export const PaginationSelectedBackgroundColor = DarkBackgroundColor;
export const NoConcertsLinkColor = TextColor;
export const FilterSliderColor = "rgb(0, 0, 0)";
export const FilterThumbColor = "rgb(188, 97, 97)";
export const NotificationsBackgroundColor = ConcertListBackgroundColor;
export const ErrorMessageColor = DarkBorderColor;

// search bar glow
export const SearchBarGlowColor = "rgb(59, 130, 246)";
export const SearchBarGlowShadow =
  "0 6px 18px rgba(186, 54, 54, 0.78), 0 0 8px rgba(192, 54, 54, 0.63)";
export const SearchBarGlowBorderColor = "rgba(186, 54, 54, 0.6)";

export const LinkColorTransitionDuration = "0.2s";
export const TransitionDuration = "0.2s";
